import React from "react";
import { ShieldCheck, CircleCheck, ArrowRight, MapPin, Truck, Clock, MessageSquare } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
const warrantyFeatures = ["Full-service residential junk removal", "Eco-friendly disposal and recycling", "Transparent, volume-based pricing", "Same-day service availability"];
export default function ExtendedWarrantyOptions() {
  return <section data-section-id="252669" id="service-overview" className="bg-background text-foreground">
      <div className="bg-foreground text-background relative overflow-hidden py-20 lg:py-32">
        {}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
          <div className="absolute -bottom-[20%] -left-[10%] w-[70%] h-[70%] rounded-lg bg-primary/10 blur-[120px]" />
          <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-lg bg-secondary/5 blur-[100px]" />
        </div>

        <div className="page-container relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            
            {}
            <div className="flex flex-col items-start space-y-8">
              <div className="flex flex-wrap gap-3">
                <Badge variant="outline" className="border-primary/30 bg-primary/20 text-primary px-4 py-1.5 text-sm font-default rounded-lg">
                  <ShieldCheck className="w-4 h-4 mr-2 text-primary" />
                  Premium Removal
                </Badge>
                <Badge variant="outline" className="border-primary/30 bg-primary/20 text-primary px-4 py-1.5 text-sm font-default rounded-lg">
                  <ShieldCheck className="w-4 h-4 mr-2 text-primary" />
                  Fully Insured
                </Badge>
                <Badge variant="outline" className="border-primary/30 bg-primary/20 text-primary px-4 py-1.5 text-sm font-default rounded-lg">
                  <MapPin className="w-4 h-4 mr-2 text-primary" />
                  Ottawa Owned
                </Badge>
                <Badge variant="outline" className="border-primary/30 bg-primary/20 text-primary px-4 py-1.5 text-sm font-default rounded-lg">
                  <Clock className="w-4 h-4 mr-2 text-primary" />
                  Same-Day Service
                </Badge>
              </div>
              
              <div className="space-y-6">
                <h1 className="font-default text-4xl md:text-5xl lg:text-[var(--font-size-h1)] font-bold leading-tight text-primary">
                  Heavy-duty solutions for every Ottawa space
                </h1>
                <p className="text-lg md:text-xl font-default text-background/80 leading-relaxed max-w-xl">
                  Experience JUNKR's premium approach to local removal. We handle the heavy lifting with professional precision, ensuring your property is cleared efficiently and responsibly.
                </p>
                <p className="text-sm md:text-base font-default text-background/60 max-w-xl">
                  Proudly serving local Ottawa neighborhoods: Kanata, Orleans, Nepean, and Stittsville.
                </p>
              </div>

              <ul className="space-y-4 w-full max-w-md">
                {warrantyFeatures.map((feature, index) => <li key={index} data-index={index} className="flex items-start gap-3">
                    <CircleCheck className="w-6 h-6 text-primary shrink-0 mt-0.5" />
                    <span className="text-background/90 font-default font-medium">{feature}</span>
                  </li>)}
              </ul>

              <div className="pt-4 flex flex-col sm:flex-row flex-wrap gap-4 w-full sm:w-auto">
                <Button asChild size="lg" className="text-base h-14 px-8 bg-primary text-primary-foreground hover:bg-primary/90 font-default rounded-lg">
                  <Link to="/ServicesPage">
                    Explore Services
                    <ArrowRight className="w-5 h-5 ml-2" />
                  </Link>
                </Button>
                <Button asChild variant="outline" size="lg" className="text-base h-14 px-8 bg-transparent border-background/20 text-background hover:bg-background/10 hover:text-background font-default rounded-lg">
                  <Link to="/PricingPage">
                    View Pricing
                  </Link>
                </Button>
                <Button asChild size="lg" className="text-base h-14 px-8 bg-secondary text-secondary-foreground hover:bg-secondary/90 font-default rounded-lg">
                  <Link to="tel:6135550123">
                    <MessageSquare className="w-5 h-5 mr-2" />
                    Text us photos
                  </Link>
                </Button>
              </div>
            </div>

            {}
            <div className="relative w-full max-w-2xl mx-auto lg:mx-0">
              <div className="relative rounded-lg overflow-hidden shadow-lg shadow-black/50 border border-slate-400/20 aspect-[4/3] lg:aspect-square">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/junkr_branded_truck_team.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/junkr_branded_truck_team.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/junkr_branded_truck_team.png-wvc-sizes" alt="Professional JUNKR team with branded truck in Ottawa" className="w-full h-full object-cover" loading="lazy" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-foreground/10 to-transparent" />
                
                {}
                <div className="absolute bottom-6 left-6 right-6 bg-background/10 backdrop-blur-md border border-background/20 rounded-lg p-6 flex items-center gap-4">
                  <div className="bg-primary/20 p-3 rounded-lg shrink-0">
                    <Truck className="w-8 h-8 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-default font-bold text-primary text-xl">Local & Reliable</h3>
                    <p className="text-background/80 text-sm mt-1 font-default">Serving the greater Ottawa area with pride</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}